import { Layout } from 'antd';
import { StyleFooter } from './style';

function Footer() {
  const { Footer } = Layout;

  return (
    <StyleFooter>
      <Footer id="footer">
        &copy; Talenta.co - Advanced Payroll Automation &amp; HR Solution
      </Footer>
    </StyleFooter>
  );
}

export default Footer;
